<script>
import FillDialog from "@/components/Sheet/FillDialog"
import { loadingService } from "@/utils/ui"
import { beforeSubmit } from "@/utils/sheet"
import { completeTask } from "@/api/project/task"

export default {
  name: "TaskFillDialog",
  extends: FillDialog,
  props: {
    projectInfo: Object,
    needFill: Boolean,
    needDueReason: Boolean,
    taskId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      submitDirectly: false // 控制HTML模板
    }
  },
  computed: {
    title() {
      return "填写 任务成果" // 覆写 dialog 的标题
    }
  },
  methods: {
    async submit(saveOnly) {
      if (this.loading) {
        this.$message.warning("请等待加载完成后操作")
        return
      }
      if (!(await this.validate())) {
        this.scrollToFormValidateErr()
        return
      }
      if (this.needDueReason && this.overDueReason.length === 0) {
        this.$message.warning("请选择逾期原因")
        return
      }
      const loading = loadingService({ text: "请求中" })
      try {
        let submitData = beforeSubmit({ form: this.form, fieldsMap: this.formUtil.controlMap })
        if (this.needDueReason) {
          submitData.overDueReason = this.overDueReason
          submitData.overDueRemark = this.overDueRemark
        }
        let res = await completeTask(
          this.taskId,
          {
            id: this.dataId,
            data: submitData
          },
          saveOnly
        )
        this.$message.success("保存成功！")
        this.$emit("after-submit", res || {}, this.from)
        this.close()
      } finally {
        loading.close()
      }
    }
  }
}
</script>
